import { Component, input } from '@angular/core';
import { Components } from '../../../components';
import { DynamicModule } from 'ng-dynamic-component';
import { RdsDividerModule, RdsIconsModule } from '@rds/angular-components';

@Component({
  selector: 'inexp-offering-capabilities-list',
  imports: [DynamicModule, RdsIconsModule, RdsDividerModule],
  templateUrl: './offering-capabilities.component.html',
  styleUrl: './offering-capabilities.component.scss',
})
export class OfferingCapabilitiesComponent {
  _uid = input<string>();
  component = input<string>();
  section = input<string>();
  capabilities = input<any[]>();
}
